import { useParams } from "react-router";
import { useLayout } from "@agentsaas/ui";
import { MobileProject } from "../mobile/MobileProject";
import { Loading } from "../layout/Loading";
import { NotFound } from "./NotFound";
import { useAgents, useProject } from "../data/queries";
import { Workspace } from "../layout/shell";
import { TeamList } from "../agent/TeamList";
import { AgentComputer } from "../agent/AgentComputer";
import { TeamPanel } from "../team/TeamPanel";
import { ProjectChrome, ProjectNav } from "../project/ProjectChrome";

/** 项目工作区：未选 agent 时主区是团队面板；选中 agent 时进入它的电脑 */
export function ProjectPage() {
  const { pid = "", aid } = useParams();
  const project = useProject(pid);
  const agents = useAgents(pid);
  const agent = agents.data?.find((a) => a.id === aid);
  const mobile = useLayout() === "mobile";

  const chrome = <ProjectChrome pid={pid} />;
  // 项目不存在 / 无权访问（例如旧链接、演示库重建后）：给出提示与返回入口，而不是一直转圈
  if (project.isError || agents.isError) return <NotFound />;
  if (project.isPending || agents.isPending)
    return (
      <>
        {chrome}
        <Loading />
      </>
    );
  if (mobile)
    return (
      <>
        {chrome}
        <MobileProject pid={pid} agent={agent} agents={agents.data ?? []} />
      </>
    );
  return (
    <>
      {chrome}
      <div className="pframe">
        <ProjectNav pid={pid} active="team" />
        <div className="pframe__body">
          {agent ? (
            <AgentComputer key={agent.id} pid={pid} agent={agent} agents={agents.data ?? []} />
          ) : (
            <Workspace sidebar={<TeamList pid={pid} agents={agents.data ?? []} />} main={<TeamPanel pid={pid} agents={agents.data ?? []} />} aside={null} />
          )}
        </div>
      </div>
    </>
  );
}
